import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { useRegisterUser } from '../../../hooks/users/useRegisterUser';

export default function RegistrationForm({ successCallback = null, userInvite = null, open, onClose }) {
    const { t } = useTranslation('common'); 

    const [password, setPassword] = React.useState("");
    const [passwordAgain, setPasswordAgain] = React.useState("");
    const [activationCode, setActivationCode] = React.useState("");

    const { register } = useRegisterUser(successCallback);

    const { showSnackbar } = useSnackbar();

    const handleSave = async () => {

      if (!activationCode.trim()) {
        showSnackbar(t('user_invites.messages.activation_code_required'), "warning");
        return;
      }
      if (!password.trim()) {
        showSnackbar(t('user_invites.messages.password_required'), "warning");
        return;
      }
      if (password.trim().length < 6) {
        showSnackbar(t('user_invites.messages.password_too_short'), "warning");
        return;
      }
      if (password.trim() !== passwordAgain.trim()) {
        showSnackbar(t('user_invites.messages.password_must_match'), "warning");
        return;
      }

      try 
      {
        await register({ 
          hash: userInvite.hash,
          password: password,
          activation_code: activationCode
        });
        showSnackbar(t('user_invites.messages.registration_success'), "success");
        onClose();     // close dialog
      } catch (err) {
        showSnackbar(t('user_invites.messages.registration_fail'), "error");
      }
    };

    const handleCancel = () => {
        setPassword("");   // clear field on cancel
        setPasswordAgain("");
        setActivationCode("");
        onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>Activate Account</DialogTitle>

        <DialogContent dividers>
          <Stack spacing={1}>
            <Typography variant='body1'>{userInvite.name}</Typography>
            <Typography variant='body2'>{userInvite.email}</Typography>
            <TextField
              label="Enter Activation Code"
              variant="outlined"
              value={activationCode}
              onChange={(e) => setActivationCode(e.target.value)}
              fullWidth
            />
            <Typography variant='body2'>Activation Code can be found in the E-mail sent to you.</Typography>
            <TextField
              label="Provide Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              label="Retype Password"
              type="password"
              fullWidth
              margin="normal"
              value={passwordAgain}
              onChange={(e) => setPasswordAgain(e.target.value)}
            />
            <Typography variant='body2'>Please provide a password that you will use for signing in.</Typography>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleSave}>
            Submit
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}